import { useCallback, useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Card } from "../ui/card";
import { Tabs, TabsList, TabsTrigger } from "../ui/tabs";
import { SeoPageEditor } from "./seo-pages/SeoPageEditor";
import { SERVICE_PAGES, SEO_PAGE_ADMIN_LABELS } from "../../data/servicePages";

export const AdminSeoPages = () => {
  const [pages, setPages] = useState([]);
  const [activePageId, setActivePageId] = useState(SERVICE_PAGES[0].pageId);
  const [loading, setLoading] = useState(true);

  const load = useCallback(() => api.get("/admin/seo-pages").then((r) => setPages(r.data)), []);

  useEffect(() => {
    load().finally(() => setLoading(false));
  }, [load]);

  const handleSaved = (updated) => setPages((ps) => ps.map((p) => (p.page_id === updated.page_id ? updated : p)));

  const activePage = pages.find((p) => p.page_id === activePageId);
  const activeSlug = SERVICE_PAGES.find((p) => p.pageId === activePageId)?.slug;

  if (loading) return <p className="text-muted-foreground">Cargando páginas...</p>;

  return (
    <Card className="p-6 space-y-6" data-testid="admin-seo-pages-panel">
      <div>
        <h3 className="font-semibold">Contenido de páginas SEO</h3>
        <p className="text-sm text-muted-foreground">
          Edita el contenido de tus páginas de servicio públicas. Los cambios se publican de inmediato en el sitio, sin necesidad de tocar código.
        </p>
      </div>

      <Tabs value={activePageId} onValueChange={setActivePageId}>
        <TabsList data-testid="admin-seo-pages-tabs" className="flex-wrap h-auto">
          {SERVICE_PAGES.map((p) => (
            <TabsTrigger key={p.pageId} value={p.pageId} data-testid={`admin-seo-pages-tab-${p.pageId}`}>
              {SEO_PAGE_ADMIN_LABELS[p.pageId]}
            </TabsTrigger>
          ))}
        </TabsList>
      </Tabs>

      {activePage && <SeoPageEditor key={activePageId} page={activePage} slug={activeSlug} onSaved={handleSaved} />}
    </Card>
  );
};
